<template>
    <div class="price-container container">
        <div class="row" v-if="title">
            <h2 class="col-sm-12 heading heading--1 price-container__heading" v-html="title"></h2>
        </div>
        <div class="row justify-content-center">
          <div class="col-md-10 col-lg-8 col-xl-6">
            <div class="row justify-content-center">
                <template v-for="price in prices">
                    <div v-if="price.title && price.key !== 'Z' && price.mainprice !== 'true'" :class="priceClass" :key="price.id">
                        <div class="price-container__prices">
                            <price-preview :price="price" :big-logo="bigLogo"></price-preview>
                        </div>
                    </div>
                </template>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
    import PricePreview from "./PricePreview";
    export default {
        components: {PricePreview},
        props: ["prices", "title"],
        computed: {
          priceClass() {
            if (this.prices.length === 1) {
              return "col-12 price-container__col";
            }
            return "col-12 col-md-6 price-container__col";
          },
          bigLogo() {
            if (this.prices.length === 1) {
              return true;
            }
            return false;
          },
        }
    }
</script>

<style lang="scss">
    .price-container {
        margin-bottom: 0;

        @media (max-width: 1203px) {
            margin-bottom: 0;
        }

        &:first-of-type {
          margin-bottom: 50px;
        }

        &__col {
            margin-bottom: 20px;
        }

        &__heading {
            &.heading {
                margin-bottom: 40px;
            }
        }

        &__prices {
            margin-bottom: 5px;
            padding: 20px;
            height: 100%;
            background-color: #fafafa;
            position: relative;
        }
    }
</style>


